export const SUB_HEADING =
    'Please review the pricing estimate your dealer has provided. Your dealer can assist with any questions you may have.'
export const TRADEMARK_SYMBOL = '®'
export const PDS = 'pds'

export const MI = 'MI'
export const MO = 'MO'

export const TOTAL_PROTECTION_PLANS = 'Total Protection Plans'
export const TRADE_IN = 'Net Trade-In'
export const VEHICLE_PURCHASE_DETAILS = 'Vehicle Purchase Details'
export const TOTAL_ACCESSORIES = 'Accessories'
export const CAPITALIZED_COST_BREAKDOWN = 'Capitalized Cost Breakdown'
export const VEHICLE_PRICING_DETAIL = 'Vehicle Pricing Detail'
export const TAXES_AND_FEES = 'Taxes and Fees'
export const TOTAL_CREDIT_CARD_PAYMENT = 'Total Credit Card Payment'
export const TOTAL_CAPITALIZED_COST_REDUCTIONS = 'Total Capitalized Cost Reductions'
export const LEASE_PAYMENT = 'Lease Payment'
export const AMOUNTS_DUE_AT_SIGNING = 'Amounts Due At Signing'
export const FIRST_MONTHLY_PAYMENT = 'First Monthly Payment'
export const TOTAL_CAPITALIZED_COST_REDUCTION = 'Capitalized Cost Reduction'
export const OTHER_UPFRONT_COSTS = 'Other Upfront Costs'
export const AMOUNTS_DUE_AT_LEASE_SIGNING = 'Amounts Due at Lease Signing'
export const HOW_AMOUNTS_DUE_WILL_BE_PAID = 'How the Amounts Due Will Be Paid'
export const NET_TRADE_IN_AMOUNT = 'Net Trade-In Amount'
export const AMOUNT_PAID_IN_CASH = 'Amounts To Be Paid In Cash/Credit Card'
export const AMOUNT_PAID_AT_LEASE_SIGNING = 'Amounts Paid at Lease Signing'
export const SURFACE_PROTECTION = 'Surface Protection'
export const CREDIT_CARD_DOWN_PAYMENT = 'Credit Card Down Payment'
export const PRICE_CHANGES_DESCRIPTION =
    'Your dealer wants you to be aware of 6 pricing changes that will impact your total. If you have questions or concerns, reach out to your dealer.'
export const TOTAL_CHANGE_POPOVER_DESCRIPTION =
    'The difference between your estimated order price and your current price provided by your dealer.'
export const DECREASES_POPOVER_DESCRIPTION = 'Pricing changes that decrease your total price.'
export const INCREASES_POPOVER_DESCRIPTION = 'Pricing changes that increase your total price.'
export const BANNER_VIN_MESSAGE =
    'Your selected vehicle has changed since you placed your order. This may impact the pricing seen here.'
export const BANNER_FIN_MESSAGE =
    'Your payment method has changed since you placed your order. This may impact the pricing seen here.'
export const BANNER_INC_PRICE_MESSAGE = 'Your price has increased since placing your order.'
export const BANNER_DEC_PRICE_MESSAGE = 'Your price has decreased since placing your order.'
export const PRICE_COMPARISON_CHANGES_ENBALED = true
export const LEASE = 'Lease'
export const CASH_DOWN_PAYMENT = 'Cash Down Payment'
export const TOTAL_DOWN_PAYMENT = 'Total Down Payment'
export const MONTHLYLOCALFEE = 'Local Fee'
export const PRIORCREDITORLEASEOWEDONTRADE = 'Prior Credit or Lease Balance'

export const BANNER_TYPE_NO_BANNER = 'No Banner'
export const BANNER_TYPE_BALANCE_ISSUE = 'no banner balance issue'
export const BANNER_TYPE_VIN_CHANGED = 'Banner VIN Changed , no CTA'
export const BANNER_TYPE_INVALID_FINANCE_TYPE_CHANGED = 'Banner finance Type Changed , no CTA'
export const BANNER_TYPE_PRICE_INCREASE = 'Banner with cta from price increase'
export const BANNER_TYPE_PRICE_DECREASE = 'Banner with cta from price decrease'
export const DEALER_SELLING_PRICE = 'Dealer Selling Price'
export const TOTAL_AVAILABLE_INCENTIVES = 'Total Available Incentives'
